import React,{ Component } from 'react';
import {Link} from 'react-router-dom'
import Navigation from '../../components/navigation'
import './index.css'
export default class info extends Component {
    state = {
        pageIndex:1
    }
    changePageIndex=(index)=>{
        this.setState({pageIndex:index})
    }
    render(){
        return (
            <main className="info_main">
                <Navigation tab="info"></Navigation>
                <div className="headlines"> 
                    <p>今日头条</p>
                    <div className="container">
                        <Link to="/info/1">
                        <div className="leftInner">
                            <img src={require('./../../pic/hot41.jpg')} alt=""></img>
                            <div className="des">
                                <p>苏州市击剑联赛暨长三角击剑公开赛总决赛延期通知</p>
                                <p>尊敬的参赛运动员：</p>
                            </div>
                        </div>
                        </Link>
                        <ul className="rightInner">
                            <Link to="/info/2">
                            <li>
                                <img src={require('./../../pic/hot51.png')} alt=""></img>
                                <div><p>全国首次！搭乘5G/VR黑科技，2019-2020赛季全国击剑冠军赛第一站28日在扬开赛</p></div>
                            </li>
                            </Link>
                            <Link to="/info/3">
                            <li>
                                <img src={require('./../../pic/hot61.jpg')} alt=""></img>
                                <div><p>2019年成都市首届中小学生比赛暨金牛区中小学生击剑锦标赛开赛</p></div>
                            </li>
                            </Link>
                            <Link to="/info/4">
                            <li>
                                <img src={require('./../../pic/hot71.jpg')} alt=""></img>
                                <div><p>高大上！击剑进校园 株洲首个小学击剑馆16日开馆</p></div>
                            </li>
                            </Link>
                            <Link to="/info/5">
                            <li>
                                <img src={require('./../../pic/hot81.jpeg')} alt=""></img>
                                <div><p>2019年市青少年击剑锦标赛落幕：多点合力共促发展</p></div>
                            </li>
                            </Link>
                            <Link to="/info/6">
                            <li>
                                <img src={require('./../../pic/hot01.jpg')} alt=""></img>
                                <div><p>合肥市首届青少年击剑锦标赛开赛！看“小小剑客”蜀山论剑~</p></div>
                            </li>
                            </Link>
                            <Link to="/info/7">
                            <li>
                                <img src={require('./../../pic/hot11.jpg')} alt=""></img>
                                <div><p>2019击剑中西部十省市对抗赛在长沙举行</p></div>
                            </li>
                            </Link>
                            <Link to="/info/8">
                            <li>
                                <img src={require('./../../pic/hot21.jpg')} alt=""></img>
                                <div><p>全国击剑冠军赛首站亚军，三明新星陈煊萍击剑稳、快、准</p></div>
                            </li>
                            </Link>
                            <Link to="/info/9">
                            <li>
                                <img src={require('./../../pic/hot33.jpg')} alt=""></img>
                                <div><p>解锁新里程碑！击剑俱乐部联赛比赛首入大型体育馆，剑客上虞齐“亮剑”</p></div>
                            </li>
                            </Link>
                        </ul>
                    </div>
                </div>  
                <div className="info">
                    <p>资讯</p>
                    <ul>
                        {this.state.pageIndex === 1 &&
                        <div>
                            <Link to="/info/10">
                                <li>
                                    <div>
                                        <p>击剑——世锦赛：中国队夺得女子重剑团体冠军</p>
                                        <p></p>
                                        <p>中国女子重剑队队员、教练员、中国击剑协会主席王海滨（前排右四）等在颁奖仪式上合影。2019布达佩斯世界击剑锦标赛21日见证了中国女子重剑队重回巅峰，由许安琪、林声、朱明叶和孙一文组成的中国队在女重团体决赛中“决一剑”击败劲旅俄罗斯队，时隔四年再次夺冠。这是中国女重继2006年和2015年后，第三次站上世锦赛团体冠军领奖台。本届世锦赛目前为止，中国斩获的一金一银均出自女重，除团体夺冠外，林声在18日的女重个人决赛上一分惜败获得银牌。</p>
                                    </div>
                                    <div className="pic">
                                        <img src={require('./../../pic/heavy_pound01.jpg')} alt=""></img>
                                    </div>
                                </li>
                            </Link>
                            <Link to="/info/11">
                                <li>
                                    <div>
                                        <p>中国选手钱佳睿获得第七届世界军人运动会女子佩剑亚军</p>
                                        <p></p>
                                        <p>当日，在武汉举行的第七届世界军人运动会女子佩剑个人赛决赛中，中国选手钱佳睿以11比15不敌俄罗斯选手埃戈里安，获得亚军。</p>
                                    </div>
                                    <div className="pic">
                                        <img src={require('./../../pic/heavy_pound11.jpg')} alt=""></img>
                                    </div>
                                </li>
                            </Link>
                            <Link to="/info/12">
                                <li>
                                    <div>
                                        <p>2019中国击剑俱乐部联赛总决赛（渭南站）明日在渭南经开区举办</p>
                                        <p></p>
                                        <p>11月27日，渭南经开区召开2019中国击剑俱乐部联赛总决赛（渭南站）协调会议。会上获悉，2019中国击剑俱乐部联赛总决赛（渭南站）将于11月29日至12月1日在渭南经开区申华汽博园举办。此次比赛由中国击剑协会主办，陕西省高尔夫击剑运动管理中心、陕西省击剑协会、渭南市体育局、渭南经济技术开发区管委会承办，渭南申华汽车文化产业园协办。赛事期间将有超过1000名运动员在12个组别行角逐。</p>
                                    </div>
                                    <div className="pic">
                                        <img src={require('./../../pic/heavy_pound21.jpg')} alt=""></img>
                                    </div>
                                </li>
                            </Link>
                            <Link to="/info/13">
                                <li>
                                    <div>
                                        <p>中国选手孙一文夺得女子重剑冠军</p>
                                        <p></p>
                                        <p>2019年10月19日 （军运会）击剑——中国选手孙一文夺得女子重剑冠军 10月19日，中国选手孙一文（左）在比赛结束与教练拥抱庆祝。 当日，在武汉举行的第七届世界军人运动会女子重剑个人赛决赛中，中国选手孙一文以11比10战胜罗马尼亚选手安娜，获得冠军。</p>
                                    </div>
                                    <div className="pic">
                                        <img src={require('./../../pic/heavy_pound31.jpg')} alt=""></img>
                                    </div>
                                </li>
                            </Link>
                            <Link to="/info/14">
                                <li>
                                    <div>
                                        <p>世锦赛：中国队获男子重剑团体第四名</p>
                                        <p></p>
                                        <p>2019年7月23日击剑——世锦赛：中国队获男子重剑团体第四名。当日，在匈牙利布达佩斯举行的2019年世界击剑锦标赛男子重剑团体三、四名决赛中，中国队以35比45不敌瑞士队，获得第四名。</p>
                                    </div>
                                    <div className="pic">
                                        <img src={require('./../../pic/heavy_pound41.jpg')} alt=""></img>
                                    </div>
                                </li>
                            </Link>
                        </div>
                        }
                        {this.state.pageIndex === 2 &&
                            <Link to="/info/15">
                                <li>
                                    <div>
                                        <p>中国击剑世锦赛史上共获8金重剑5金 中国击剑奥运会第一人是她</p>
                                        <p></p>
                                        <p>北京时间7月22日凌晨，击剑世锦赛赛场传来好消息，林声、孙一文、许安琪和朱明叶组成的中国队凭借加时赛朱明叶抢先刺中的一剑，以29比28绝杀俄罗斯，继2006年和2015年之后，中国女子重剑队第三次在世锦赛上赢得团体冠军。这是中国击剑队历史上的第8枚世锦赛金牌，到目前为止中国击剑队在历届世锦赛上共拿到了8金19银16铜，共43枚奖牌。也是在本次世锦赛林声拿到了女重个人赛的银牌。</p>
                                    </div>
                                    <div className="pic">
                                        <img src={require('./../../pic/heavy_pound51.jpg')} alt=""></img>
                                    </div>
                                </li>
                            </Link>
                        }
                    </ul>
                    <div className="page">
                        <div className="btn">
                            <div className={this.state.pageIndex === 1 ? 'active' : ''} onClick={this.changePageIndex.bind(this,1)}>1</div>
                            <div className={this.state.pageIndex === 2 ? 'active' : ''} onClick={this.changePageIndex.bind(this,2)}>2</div>
                        </div>
                    </div>
                </div>
            </main>
        )
    }
};